// extracted by mini-css-extract-plugin
export var externalLink = "_6d-0";
export var internalLinkLabel = "_6d-1";